import { Chip, Stack } from '@mui/material';

import type { InvoiceStatus } from '../api/shared';
import { useT } from '../i18n/LanguageContext';

const COLOURS: Record<InvoiceStatus, 'default' | 'success' | 'warning' | 'info'> = {
  ISSUED: 'info',
  PARTIALLY_PAID: 'warning',
  PAID: 'success',
  CANCELLED: 'default',
};

/** Where a document stands, and whether it is past its due date. */
export const InvoiceStatusChip = ({ status, overdue }: { status: InvoiceStatus; overdue: boolean }) => {
  const t = useT();

  return (
    <Stack direction="row" spacing={0.75}>
      <Chip
        size="small"
        variant="outlined"
        color={COLOURS[status]}
        label={t(`invoiceStatus.${status}` as const)}
      />
      {overdue ? <Chip size="small" variant="outlined" color="error" label={t('invoice.overdue')} /> : null}
    </Stack>
  );
};
